/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthenticationRequest,
  AuthenticationResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
  IsAuthenticatedResponse,
  ResetPasswordParameter,
  ResetPasswordRequest,
  ResetPasswordResponse,
  Result,
  UserType,
} from '../models/index';
import {
    AuthenticationRequestFromJSON,
    AuthenticationRequestToJSON,
    AuthenticationResponseFromJSON,
    AuthenticationResponseToJSON,
    ChangePasswordRequestFromJSON,
    ChangePasswordRequestToJSON,
    ChangePasswordResponseFromJSON,
    ChangePasswordResponseToJSON,
    IsAuthenticatedResponseFromJSON,
    IsAuthenticatedResponseToJSON,
    ResetPasswordParameterFromJSON,
    ResetPasswordParameterToJSON,
    ResetPasswordRequestFromJSON,
    ResetPasswordRequestToJSON,
    ResetPasswordResponseFromJSON,
    ResetPasswordResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    UserTypeFromJSON,
    UserTypeToJSON,
} from '../models/index';

export interface ChangePasswordOperationRequest {
    changePasswordRequest?: ChangePasswordRequest;
}

export interface ChangeUsernameRequest {
    username?: string;
}

export interface CheckPasswordRequest {
    password?: string;
}

export interface ExecuteResetPasswordRequest {
    resetPasswordParameter?: ResetPasswordParameter;
}

export interface LoginRequest {
    authenticationRequest?: AuthenticationRequest;
}

export interface RequestResetPasswordRequest {
    resetPasswordRequest?: ResetPasswordRequest;
}

export interface ValidatePincodeRequest {
    pincode?: string;
    userId?: string;
    userType?: UserType;
}

/**
 * 
 */
export class AuthorizationApi extends runtime.BaseAPI {

    /**
     */
    async changePasswordRaw(requestParameters: ChangePasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangePasswordResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/ChangePassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangePasswordRequestToJSON(requestParameters.changePasswordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangePasswordResponseFromJSON(jsonValue));
    }

    /**
     */
    async changePassword(requestParameters: ChangePasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangePasswordResponse> {
        const response = await this.changePasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async changeUsernameRaw(requestParameters: ChangeUsernameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.username !== undefined) {
            queryParameters['username'] = requestParameters.username;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/ChangeUsername`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async changeUsername(requestParameters: ChangeUsernameRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.changeUsernameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async checkPasswordRaw(requestParameters: CheckPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Result>> {
        const queryParameters: any = {};

        if (requestParameters.password !== undefined) {
            queryParameters['password'] = requestParameters.password;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/CheckPassword`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultFromJSON(jsonValue));
    }

    /**
     */
    async checkPassword(requestParameters: CheckPasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Result> {
        const response = await this.checkPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async executeResetPasswordRaw(requestParameters: ExecuteResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResetPasswordResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/ExecuteResetPassword`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordParameterToJSON(requestParameters.resetPasswordParameter),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPasswordResponseFromJSON(jsonValue));
    }

    /**
     */
    async executeResetPassword(requestParameters: ExecuteResetPasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResetPasswordResponse> {
        const response = await this.executeResetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getLoginTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/GetLoginToken`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getLoginToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getLoginTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async isAuthenticatedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IsAuthenticatedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/IsAuthenticated`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IsAuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     */
    async isAuthenticated(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IsAuthenticatedResponse> {
        const response = await this.isAuthenticatedRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async loginRaw(requestParameters: LoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IsAuthenticatedResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/Login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthenticationRequestToJSON(requestParameters.authenticationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IsAuthenticatedResponseFromJSON(jsonValue));
    }

    /**
     */
    async login(requestParameters: LoginRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IsAuthenticatedResponse> {
        const response = await this.loginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async logoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthenticationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/Logout`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthenticationResponseFromJSON(jsonValue));
    }

    /**
     */
    async logout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthenticationResponse> {
        const response = await this.logoutRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async requestResetPasswordRaw(requestParameters: RequestResetPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResetPasswordResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/RequestResetPassword`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordRequestToJSON(requestParameters.resetPasswordRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResetPasswordResponseFromJSON(jsonValue));
    }

    /**
     */
    async requestResetPassword(requestParameters: RequestResetPasswordRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResetPasswordResponse> {
        const response = await this.requestResetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async validatePincodeRaw(requestParameters: ValidatePincodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.pincode !== undefined) {
            queryParameters['pincode'] = requestParameters.pincode;
        }

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        if (requestParameters.userType !== undefined) {
            queryParameters['userType'] = requestParameters.userType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/AuthorizationApi/ValidatePincode`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async validatePincode(requestParameters: ValidatePincodeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.validatePincodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
